import {useTranslation} from "react-i18next";
import '../Privacy.css'

const FridgeOrganizerPrivacy = () => {
    const {t} = useTranslation();
    const sections = t('privacy.fridge_organizer.sections', {returnObjects: true});

    return (
        <div className="privacy-container">
            <h1>{t('privacy.fridge_organizer.title')}</h1>

            <p className="effective-date">{t('privacy.fridge_organizer.last_updated')}</p>
            <p>{t('privacy.fridge_organizer.intro')}</p>

            {sections.map((section) => (
                <section key={section.title}>
                    <h2>{section.title}</h2>
                    {section.body && <p>{section.body}</p>}
                    {section.items && (
                        <ul>
                            {section.items.map((item) => (
                                <li key={item}>{item}</li>
                            ))}
                        </ul>
                    )}
                </section>
            ))}

            <p>develop@persnormal.com</p>
        </div>
    );
}

export default FridgeOrganizerPrivacy;
